import React, { Component } from 'react';
import './Product.scss';
import { ProductConsumer } from '../../../Context';

class Product extends Component {
  render() {
    const { id, name, image, price, inCart } = this.props.product;
    // const { count } = this.props.value.cart;
    return (
      <li className='item' id={name}>
        <img className='item__img' src={image} alt={name} />
        <h2>{name}</h2>
        <p className='item__price'>${price.toFixed(2)}</p>
        <div className='item__addCart'>
          <ProductConsumer>
            {value => {
              return (
                <button
                  className='item__addCart__btn btn'
                  disabled={inCart ? true : false}
                  onClick={() => {
                    value.addToCart(id);
                  }}
                >
                  {inCart ? <p disabled>In Cart</p> : <p>Add to Cart</p>}
                </button>
              );
            }}
          </ProductConsumer>
        </div>
      </li>
    );
  }
}

export default Product;
